import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/styled-engine';
import { ThemeProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import loadTheme from './loadTheme';

const Theme = ({ children, siteId }) => (
	<StyledEngineProvider injectFirst>
		<MuiThemeProvider theme={loadTheme(siteId)}>
			<ThemeProvider theme={loadTheme(siteId)}>
				<React.Fragment>
					<CssBaseline />
					{children}
				</React.Fragment>
			</ThemeProvider>
		</MuiThemeProvider>
	</StyledEngineProvider>
);

Theme.propTypes = {
	children: PropTypes.node,
	siteId: PropTypes.number
};

export default Theme;
